export interface IOnTimeKidneyPickup {
    swapNumber: string,
    transplantDate: string,
    donorCenterId: number,
    donorCenter: string,
    remoteDonorCenterId: number,
    remoteDonorCenter: string,
    donorAlias: string,
    recipientCenterId: number,
    recipientCenter: string,
    recipientAlias: string,   
    scheduledPickup: string,
    actualPickup: string,
    transportationType: string,
    onTime: boolean
}